import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useReducer } from "react";
import { Colors } from "../../../styles/theme";
import { TabPanel, a11yProps } from '../../ui';
import ValidService from './validServices/validService';
import ValidLensBrand from './validLensBrand/validLensBrand';
import { Button, Stack, useMediaQuery } from '@mui/material';
import UploadIcon from '@mui/icons-material/Upload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ValidLensModel from './validLensModel/validLensModel';
import ValidFrameBrand from './validFrameBrand/validFrameBrand';
import ValidFrameModel from './validFrameModel/validFrameBrand';
import ValidEncouner from './validEncounter/validEncounter';
import ValidSupplier from './validSupplier/validSupplier';
import Frames from '../inventory/frames/frames';
import Lenses from '../inventory/lenses/lenses';
import ValidTreatment from './validTreatment/validTreatment';
import ValidLabs from './validLabs/validLabs';
import ValidManufacturer from './validManufacturer/validManufacturer';
import ValidLensTreatment from './validLensTreatment/validLensTreatment';
import ValidLensMaterial from './validLensMaterial/validLensMaterial';
import ValidLensIndex from './validLensIndex/validLensIndex';
import LensPricingMatrix from './lensPricingMatrix/lensPricingMatrix';
//import Lenses from './lenses/lenses';

const ValidTabEnum = {
    SELECT_TAB: "Select an item",
    ORDER_SERVICES: 'Services',
    ENCOUNTERS: 'Encounters',
    SUPPLIER: 'Suppliers',
    FRAMES: 'Frames',
    LENS_BRAND: 'Lense Brands',
    CONTACTS: 'Contacts',
    ACCESSORIES: 'Accessories',
    TREATMENTS: 'Treatments',
    LABS: 'Labs',
    MANUFACTURERS: 'Manufacturers',
    // LENS_TREATMENTS: 'Lens Treatments',
    // LENS_MATERIALS: 'Lens Materials',
    // LENS_INDEXES: 'Lens Indexes',
    // LENS_MODELS: 'Lens Models',
    // LENS_PRICING: 'Lens Pricing Matrix',
}

export default function ValidData() {
    const isMobile = true; //useMediaQuery(theme => theme.breakpoints.down('xl'));
    const [state, updateState] = useReducer((state, params) => {
        return { ...state, ...params };
    }, {
        selectedItem: 0,
    });

    const handleTabChange = (event, newValue) => {
        updateState({
            selectedItem: newValue
        });
    }

    return (
        <Box display={'flex'} flexDirection={'column'}>
            <Stack direction={'row'} justifyContent={'flex-end'}>
                <Button variant='outlined' startIcon={<UploadIcon />}>Import</Button>
                <Button variant='outlined' startIcon={<FileDownloadIcon />}>Export</Button>
            </Stack>
            <Box sx={{ flexGrow: 1, display: isMobile ? 'block' : 'flex' }}>
                <Tabs
                    orientation={isMobile ? 'horizontal' : 'vertical'}
                    variant="scrollable"
                    value={state.selectedItem}
                    onChange={handleTabChange}
                    aria-label="Valid data"
                    sx={{ 
                        borderRight: 1, borderColor: 'divider' }}
                    >
                    <Tab label={ValidTabEnum.ORDER_SERVICES} {...a11yProps(0)} />
                    <Tab label={ValidTabEnum.ENCOUNTERS} {...a11yProps(1)} />
                    <Tab label={ValidTabEnum.SUPPLIER} {...a11yProps(2)} />
                    {/* <Tab label={ValidTabEnum.TREATMENTS} {...a11yProps(3)} /> */}
                    <Tab label={ValidTabEnum.LABS} {...a11yProps(3)} />
                    <Tab label={ValidTabEnum.MANUFACTURERS} {...a11yProps(4)} />
                    {/* <Tab label={ValidTabEnum.LENS_TREATMENTS} {...a11yProps(5)} />
                    <Tab label={ValidTabEnum.LENS_MATERIALS} {...a11yProps(6)} />
                    <Tab label={ValidTabEnum.LENS_INDEXES} {...a11yProps(7)} />
                    <Tab label={ValidTabEnum.LENS_MODELS} {...a11yProps(8)} />
                    <Tab label={ValidTabEnum.LENS_PRICING} {...a11yProps(9)} /> */}
                    {/* <Tab label={ValidTabEnum.LENS_BRAND} {...a11yProps(4)} /> */}
                </Tabs>
                <Box sx={{ width: '100%' }}>
                    <TabPanel value={state.selectedItem} index={0}>
                        <ValidService />
                    </TabPanel>
                    <TabPanel value={state.selectedItem} index={1}>
                        <ValidEncouner />
                    </TabPanel>
                    <TabPanel value={state.selectedItem} index={2}>
                        <ValidSupplier />
                    </TabPanel>
                        {/* <TabPanel value={state.selectedItem} index={3}>
                            <ValidTreatment />
                        </TabPanel> */}
                    <TabPanel value={state.selectedItem} index={3}>
                        <ValidLabs />
                    </TabPanel>
                    <TabPanel value={state.selectedItem} index={4}>
                        <ValidManufacturer />
                    </TabPanel>
                    {/* <TabPanel value={state.selectedItem} index={5}>
                        <ValidLensTreatment />
                    </TabPanel>
                    <TabPanel value={state.selectedItem} index={6}>
                        <ValidLensMaterial />
                    </TabPanel>
                    <TabPanel value={state.selectedItem} index={7}>
                        <ValidLensIndex />
                    </TabPanel>
                    <TabPanel value={state.selectedItem} index={8}>
                        <ValidLensModel />
                    </TabPanel>
                    <TabPanel value={state.selectedItem} index={9}>
                        <LensPricingMatrix />
                    </TabPanel> */}
                    {/*    
                    <TabPanel value={state.selectedItem} index={4}>
                        <Lenses />
                    </TabPanel>                                      */}
                    {/* <TabPanel value={state.selectedItem} index={4}>
                        <ValidLensBrand />
                    </TabPanel> */}
                    {/*<TabPanel value={state.selectedItem} index={5}>
                        <ValidFrameBrand />
                    </TabPanel> */}
                    {/* <TabPanel value={state.selectedItem} index={6}>
                        <ValidLensModel />
                    </TabPanel>
                    <TabPanel value={state.selectedItem} index={7}>
                        <ValidLensSupplier />
                    </TabPanel>
                    <TabPanel value={state.selectedItem} index={8}>
                        <ValidFrameSupplier />
                    </TabPanel> */}
                </Box>

            </Box>
        </Box>

    );
}